import { getSearchUrl } from 'helpers/namedUrls';

export const isAbleToGoBack = ({ isCurrentHost, historyLength }) =>
  isCurrentHost && historyLength > 0;

export const onClick = (forceRefresh) =>
  function* ({ referer, routeHelpers }) {
    if (
      isAbleToGoBack({
        isCurrentHost: referer.isCurrentHost() || !forceRefresh,
        historyLength: routeHelpers.gerHistoryLength(),
      })
    ) {
      yield routeHelpers.goBack();
    } else {
      yield routeHelpers.pushRoute({ pathname: getSearchUrl() });
    }
  };
